import { apiGet } from "../../../../API/Service/apiClient";
import { handleCheckUserLogin } from "../../../../MIS/Global";

export const handleGetOrder_list = async ({  
  filter,setLoading,setTotalPage,setQuotations
  }) => {
  setLoading(true);  
  try {
    const resData = await apiGet("quotation",filter);             
    setQuotations(resData?.data);
    setTotalPage(resData?.total_pages) 
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);
  }
};

export const handleGetAddons_list = async ({  
  setAddonLoading,
  setAddons,
  }) => {
    setAddonLoading(true);
  try {
    const resData = await apiGet("addons", {page:1,limit:100});         
    setAddons(resData?.data)
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setAddonLoading(false);
  }
};

export const handleOrderStatus = (quote_status, due_date) => {
  const status = quote_status;

  // Today's date in UTC (ignore time)
  const todayUTC = new Date();
  const currentDateUTC = new Date(
    Date.UTC(todayUTC.getUTCFullYear(), todayUTC.getUTCMonth(), todayUTC.getUTCDate())
  );
  // Convert due_date to UTC midnight
  const dueDateUTC = new Date(`${due_date}T00:00:00Z`);  
  if(status==="Accept"){
    if (dueDateUTC <= currentDateUTC) {
      return "Delivered";
    }else{
      return status;
    }
  }else{
    return status;
  }
   
  
};

export const handlePrev = ({setPage,page,setFilter}) => {
  const newPage = Math.max(page - 1, 1); 
  setFilter((prev) => ({
    ...prev,
    page:newPage,
  }));
  setPage((prev) => Math.max(prev - 1, 1));
};

export const handleNext = ({setPage,page,totalPage,setFilter}) => {
  const newPage = Math.min(page + 1, totalPage);  
  setFilter((prev) => ({
    ...prev,
    page:newPage,
  }));
  setPage((prev) => Math.min(prev + 1, totalPage));
};  

export const handleChangeSearch=({value,setSearch})=>{
  setSearch(value);
}

export const handleEditButton_visible=(quote_status, due_date)=>{
  const status = quote_status;

  // Today's date in UTC (ignore time)
  const todayUTC = new Date();
  const currentDateUTC = new Date(
    Date.UTC(todayUTC.getUTCFullYear(), todayUTC.getUTCMonth(), todayUTC.getUTCDate())
  );
  // Convert due_date to UTC midnight
  const dueDateUTC = new Date(`${due_date}T00:00:00Z`);  
  if (status === "Accepted") {
    if (dueDateUTC <= currentDateUTC) {
      return "d-none";
    }else {return "";}
  } else{
    return "";
  }
}

export const handleStatus_Label = (quote_status) => {
  const statusMap = {
    0: { label: "Pending", className: "bg-warning text-dark" },
    1: { label: "Accepted", className: "bg-success" },
    2: { label: "Cancelled", className: "bg-danger" },
    3: { label: "Processing", className: "bg-primary" },
    4: { label: "Draft", className: "bg-secondary" },
  };

  const currentStatus = statusMap[quote_status] || {
    label: "Unknown",
    className: "bg-dark",
  };

  return currentStatus.className;
};